import { Dispatch, FC, SetStateAction } from 'react';

import { UserInfo } from '@/api/data-contracts';
import Avatar from '@/shared/ui/Avatar';

import { MenuButton, ProfileButtonLabel } from './styled';

interface Props {
  userInfo: UserInfo | undefined;
  setIsMenuExpanded: Dispatch<SetStateAction<boolean>>;
  isExpanded: boolean;
}

const AccountButton: FC<Props> = ({ userInfo, setIsMenuExpanded, isExpanded }) => (
  <MenuButton
    variant="text"
    isExpanded={isExpanded}
    onClick={isExpanded ? () => setIsMenuExpanded((prev) => !prev) : undefined}
    sx={{
      gap: isExpanded ? '0.62rem' : 0,
      padding: isExpanded ? '0.5rem' : 0,
      justifyContent: isExpanded ? 'flex-start' : 'center',
      borderRadius: isExpanded ? '0.75rem !important' : '50% !important',
      overflow: 'visible',
    }}
    data-testid="account-menu-toggle"
  >
    <Avatar
      currentUser
      priority
      name={userInfo?.name}
      sx={{
        width: '2.48rem',
        height: '2.48rem',
        flexShrink: 0,
        backgroundColor: 'transparent',
      }}
    />

    <ProfileButtonLabel data-testid={'loggedInUser'} isExpanded={isExpanded}>
      {userInfo?.name ?? ''}
    </ProfileButtonLabel>
  </MenuButton>
);

export default AccountButton;
